import * as React from "react"

import { cn } from "@/lib/utils"
import SmartDate from "../SmartDate"

const Input = React.forwardRef(({ className, type, ...props }, ref) => {
  // type="date" is famously inconsistent across browsers — year inputs
  // are tiny on Chrome, focus-stealing on Safari, and untypeable on
  // many Android WebViews. We auto-upgrade every <Input type="date" />
  // to our SmartDate (Month/Day/Year dropdowns) so the upgrade
  // propagates across the codebase without touching call sites.
  if (type === "date") {
    return <SmartDate ref={ref} className={className} {...props} />;
  }
  return (
    <input
      type={type}
      className={cn(
        "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Input.displayName = "Input"

export { Input }
